import React, { Component } from 'react';
import { observer } from 'mobx-react';
import mainStore from '../../MainStore'
import CircularProgress from '@mui/material/CircularProgress';
import './loader.css'

const Loader = observer(class Loader extends Component {

    render() {

        return <div>
            {mainStore.isMaskVisible && <div className="loader-wrapper">{this.props.children}<div className="loader"></div><div className="loader-message">Идет загрузка <CircularProgress color="secondary" /></div></div>}
        </div>;
    }
});

export default Loader;
